// Frontend list of all 11 model names - drives the locked grid that appears
// after the diagnosis. Only the name + id are needed client-side; the principles
// and lens summaries live server-side (functions/lib/frameworks.ts) so the full
// framework is never scraped from client JS.

export type ElevenModelTile = {
  id: number;
  name: string;
};

export const elevenModels: ElevenModelTile[] = [
  { id: 1, name: 'Decision Flow' },
  { id: 2, name: 'Time Horizon' },
  { id: 3, name: 'Trust Architecture' },
  { id: 4, name: 'Intelligence Tier' },
  { id: 5, name: 'Outcome Ownership' },
  { id: 6, name: 'Constraint' },
  { id: 7, name: 'Information Flow' },
  { id: 8, name: 'Uncertainty' },
  { id: 10, name: 'Energy' },
  { id: 11, name: 'Narrative' },
];

export const APPLIED_MODEL_ID = 4; // Intelligence Tier - the lens used in the free run.
